export default __webpack_public_path__ + "static/media/grafema_pilates_04.9184ff68.jpg";